export default "__VITE_ASSET__CscVLoSB__"